import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'apps/stock/src/environments/environment';

@Component({
  selector: 'card-trader',
  templateUrl: './card-trader.component.html',
  styleUrls: ['./card-trader.component.scss'],
})
export class CardTraderComponent implements OnInit {
  public isNewBrand = environment.isNewBrand;

  @Input() public cardOne: boolean = false;
  @Input() public cardTwo: boolean = false;
  @Input() public cardThree: boolean = false;
  @Input() public cardFour: boolean = false;
  public shadowOne: string = '';
  public shadowTwo: string = '';
  public shadowThree: string = '';
  public shadowFour: string = '';

  constructor() {
    /** */
  }

  ngOnInit() {
    this.getShadow();
  }

  public getShadow(): void {
    this.shadowOne = this.cardOne ? 'shadow' : '';
    this.shadowTwo = this.cardTwo ? 'shadow' : '';
    this.shadowThree = this.cardThree ? 'shadow' : '';
    this.shadowFour = this.cardFour ? 'shadow' : '';
  }
}


